
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import AnalysisHistory from "./AnalysisHistory";
import type { AIAnalysisResult } from "@/hooks/useAIAnalysis";

interface AnalysisActionsProps {
  onBackToHome: () => void;
  onSelectPreviousAnalysis: (analysis: AIAnalysisResult, date: string) => void;
}

const AnalysisActions = ({ onBackToHome, onSelectPreviousAnalysis }: AnalysisActionsProps) => {
  const { t } = useTranslation('ai-analysis');
  return (
    <div className="flex justify-center gap-4 print:hidden">
      <Button onClick={onBackToHome} variant="outline">
        {t('actions.backToHome')}
      </Button>
      <AnalysisHistory onSelectAnalysis={onSelectPreviousAnalysis} />
      <Button onClick={() => window.print()} variant="outline">
        {t('actions.print')}
      </Button>
    </div>
  );
};

export default AnalysisActions;
